import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography
} from '@material-ui/core';
import { useState, useEffect } from 'react';
import validate from 'validate.js';
import { useLanguageSettings } from '../../Settings/useLanguageSettings'

const schema = (validatorMessages) => {
  return {
    email: {
      presence: { 
        allowEmpty: false,
        message: `^${validatorMessages?.testTemplateEmailEmptyError || `Email can't be blank`}`
      },
      email: {
        message: `^${validatorMessages?.testTemplateEmailInvalidError || `Email is not a valid email`}`
      },
    },
    number: {
      presence: { 
        allowEmpty: false,
        message: `^${validatorMessages?.testTemplateSmsEmptyError || `Number can't be blank`}`
      },
      format: { 
        pattern: '[+]{1}[0-9]{1,20}',
        message: `^${validatorMessages?.testTemplateSmsInvalidError || `Number is invalid`}`
      }
    }
  };
};

export default function VerifyTemplate(props) {
  const {
    templateType,
    openModel,
    closeModel,
    getTestTemplate,
    isTestingTemplate,
    isTestingSucceeded } = props;

  const { templateLanguageContent, getTemplateLanguageContent } = useLanguageSettings();
  const [verifyTemplateContent, setVerifyTemplateContent] = useState(null);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  const [showTestResult, setShowTestResult] = useState(false);

  useEffect(() => {
    if (templateLanguageContent) {
      setVerifyTemplateContent(getTemplateLanguageContent("components", "verifyTemplate"));
    }
  }, [templateLanguageContent]);

  useEffect(() => {
    const errors = validate(formState.values, schema(verifyTemplateContent || {}));
    setShowTestResult(false);
    setFormState(formState => ({
      ...formState,
      isValid: templateType === 'EMAIL' ? (errors.email ? false : true) : (errors.number ? false : true),
      errors: errors || {}
    }));
  }, [formState.values]);


  const handleChange = event => {
    event.persist();
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleClose = () => {
    closeModel()
    setFormState({
      isValid: false,
      values: {},
      touched: {},
      errors: {}
    })
  };

  const validateTemplates = event => {
    event.preventDefault();
    setShowTestResult(true);
    templateType === 'EMAIL' ?
      getTestTemplate(formState.values.email)
      :
      getTestTemplate(formState.values.number)
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div>
      <Dialog open={openModel}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{verifyTemplateContent?.testTemplateTitle || `Test Template`}</DialogTitle>
        {templateType === 'EMAIL' ? (
          <DialogContent>
            <DialogContentText>
              {verifyTemplateContent?.testTemplateEmailSubTitle || `To test this template enter your email address.`}
          </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              helperText={hasError('email') ? formState.errors.email[0] : null}
              value={formState.values.email || ''}
              error={hasError('email')}
              onChange={handleChange}
              id="name"
              label={verifyTemplateContent?.testTemplateEmailLabel || `Email Address`}
              type="email"
              name="email"
              fullWidth
            />
          </DialogContent>) :
          (<DialogContent>
            <DialogContentText>
              {verifyTemplateContent?.testTemplateSmsSubTitle || `To test this template enter your Mobile Number.`}
          </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id='number'
              helperText={hasError('number') ? formState.errors.number[0] : null}
              value={formState.values.number || ''}
              error={hasError('number')}
              onChange={handleChange}
              label={verifyTemplateContent?.testTemplateSmsLabel || `Mobile Number`}
              type='phone'
              name="number"
              fullWidth
            />
          </DialogContent>)}
        {showTestResult && !isTestingTemplate && <DialogContent>
          {isTestingSucceeded === true && <Typography variant="subtitle2" color='primary'>
            {verifyTemplateContent?.testTemplateSuccessMessage[0] || `Test`} {templateType === 'EMAIL' ? `${verifyTemplateContent?.testTemplateEmailKeyword || `E-mail`}` : `${verifyTemplateContent?.testTemplateSmsKeyword || `SMS`}`} {verifyTemplateContent?.testTemplateSuccessMessage[1] || `was successfully initiated.`}
        </Typography>}
          {isTestingSucceeded === false && <Typography variant="subtitle2" color='error'>
           {verifyTemplateContent?.testTemplateFailedMessage[0] || `Failed to send a test`} {templateType === 'EMAIL' ? `${verifyTemplateContent?.testTemplateEmailKeyword || `E-mail`}` : `${verifyTemplateContent?.testTemplateSmsKeyword || `SMS`}`}.
        </Typography>}
        </DialogContent>}
        <DialogActions>
          <Button
            disabled={!formState.isValid || isTestingTemplate}
            onClick={validateTemplates} >
            {verifyTemplateContent?.testTemplateTestButtonLabel || `Test`}
          </Button>
          <Button
            onClick={handleClose} >
            {verifyTemplateContent?.testTemplateCloseButtonLabel || `Close`}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
